export default `
  linking(cityId: $cityId, locale: $locale) {
    anchorText
    url
  }
`;